import CategoryType from './CategoryType'

const categoryReducer = (state, action) => {
  switch (action.type) {
    case CategoryType.GET_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        loading: false,
      }
    case CategoryType.GET_CATEGORY:
      return {
        ...state,
        category: action.payload,
        loading: false,
      }
    case CategoryType.CREATE_CATEGORY:
      return {
        ...state,
        category: action.payload,
        loading: false,
      }
    case CategoryType.UPDATE_CATEGORY:
      return {
        ...state,
        category: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default categoryReducer
